import { TIFDEDSignature, TIFDonorInfo, TIFGrading, TIFHeader, TIFSerologies, TIFShipping, TIFSummaryRecords } from ".";
import { useTIFFormData } from "../../../../hooks";

export interface TissueInformationFormProps {
    tissueId?: number;
}

export function TissueInformationForm({ tissueId }: Readonly<TissueInformationFormProps>) {
    const { tissue } = useTIFFormData({ tissueId });

    if (!tissue) {
        return (
            <div>
                <h1>Tissue Information Form</h1>
                <div>No tissue found</div>
            </div>
        );
    }

    return (
        <div style={{ maxWidth: "800px" }}>
            <h1>Tissue Information Form</h1>
            <TIFHeader tissueId={tissue.id} />
            <TIFDonorInfo tissueId={tissue.id} />
            <TIFSummaryRecords tissueId={tissue.id} />
            <TIFSerologies tissueId={tissue.id} />
            <TIFDEDSignature tissueId={tissue.id} />
            <TIFGrading tissueId={tissue.id} />
            <TIFShipping tissueId={tissue.id} />
        </div>
    );
}
